import {
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerProps,
  FormControl,
  FormLabel,
  Stack,
} from '@chakra-ui/react';
import { PostRoleRequest } from 'api/bindings/PostRoleRequest';
import { AppInput, FormButtonGroup } from 'features/components';
import { FormProvider, useForm } from 'react-hook-form';

export interface CreateClientRoleFormDrawerProps
  extends Omit<DrawerProps, 'onSubmit' | 'children'> {
  onSubmit: (role: PostRoleRequest) => void;
  onClose: () => void;
}

interface Form extends PostRoleRequest {}

export const CreateClientRoleFormDrawer = (props: CreateClientRoleFormDrawerProps) => {
  let { onSubmit, onClose, ...rest } = props;

  // State
  const form = useForm<Form>({
    mode: 'all',
    defaultValues: {
      name: '',
      defaultAfeApprovalAuthority: '0',
      defaultPurchaseOrderApprovalAuthority: '0',
      defaultWorkOrderApprovalAuthority: '0',
      defaultInvoiceApprovalAuthority: '0',
    },
  });
  const { register, watch, handleSubmit } = form;
  const formName = watch('name');

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DrawerContent {...rest}>
          <DrawerCloseButton />
          <DrawerHeader>Create Role: {formName || 'New Role'}</DrawerHeader>
          <DrawerBody>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel htmlFor="name">Name:</FormLabel>
                <AppInput
                  id="name"
                  {...register('name', {
                    required: 'Name is required',
                    minLength: 3,
                    maxLength: 256,
                  })}
                />
              </FormControl>
            </Stack>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel htmlFor="defaultAfeAuthority">
                  AFE Authority:
                </FormLabel>
                <AppInput
                  id="defaultAfeAuthority"
                  type="currency"
                  {...register('defaultAfeApprovalAuthority')}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="defaultPoAuthority">
                  Purchase Order Authority:
                </FormLabel>
                <AppInput
                  id="defaultPoAuthority"
                  type="currency"
                  {...register('defaultPurchaseOrderApprovalAuthority')}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="defaultWoAuthority">
                  Work Order Authority:
                </FormLabel>
                <AppInput
                  id="defaultWoAuthority"
                  type="currency"
                  {...register('defaultWorkOrderApprovalAuthority')}
                />
              </FormControl>
              <FormControl>
                <FormLabel htmlFor="defaultInvAuthority">
                  Invoice Authority:
                </FormLabel>
                <AppInput
                  id="defaultInvAuthority"
                  type="currency"
                  {...register('defaultInvoiceApprovalAuthority')}
                />
              </FormControl>
            </Stack>
          </DrawerBody>
          <DrawerFooter>
            <FormButtonGroup
              onCancel={onClose}
              onConfirm={handleSubmit(onSubmit)}
            />
          </DrawerFooter>
        </DrawerContent>
      </form>
    </FormProvider>
  );
};